import React from 'react';
import Carousel from './Carousel';
import AboutUs from './AboutUs';
import OurServices from '../pages/OurServices';
import PerfectFleet from '../pages/PerfectFleet';
import LuxuryCollection from '../pages/LuxuryCollection';
import HowItWork from '../pages/HowItWork';
import WhyChooseUs from '../pages/WhyChooseUs';
import OurFaqs from '../pages/OurFaqs';
import PerfectFleets from '../pages/PerfectFleets';
import Testimonial from '../pages/Testimonial';
import Testimonials from '../pages/Testimonial';
import CtaBox from '../pages/CtaBox';
import LatestArticles from '../pages/LatestArticles';
import AaryanBookCar from '../pages/AaryanBookCar';
import AaryanCorporateSection from './AaryanCorporateSection';



const HeroSection = () => {
  
  return (


    <div className="th-hero-wrapper hero-1" id="hero">

{/* <AaryanCorporateSection/> */}

 <Carousel/>
 <AaryanBookCar/>
 {/* <AboutUs/> */}
 <OurServices/>
 <PerfectFleet/>
 {/* <LuxuryCollection/> */}
 <HowItWork/>
 <WhyChooseUs/>
 <OurFaqs/>
 {/* <PerfectFleets/> */}
 {/* <Testimonial/> */}
 <CtaBox/>

 <Testimonials/>
 {/* <LatestArticles/> */}
    </div>
  );
};

export default HeroSection;
